export const formbricksTrack = (actionKey: string): void => {
  const formbricks = (window as any).formbricks

  if (formbricks && typeof formbricks.track === "function") {
    try {
      formbricks.track(actionKey)
    } catch (error) {
      console.warn("Formbricks tracking failed:", error)
    }
  } else {
    console.warn("Formbricks tracking not available")
  }
}
